// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".date-picker-input{text-align:center}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/cafes/List/edit/styles.scss"],"names":[],"mappings":"AAAA,mBACE,iBAAkB","file":"styles.scss","sourcesContent":[".date-picker-input {\n  text-align: center;\n}"]}]);
// Exports
module.exports = exports;
